import { FeatureFlag } from '../../types/Settings.types';

export const isFeatureFlagEnabled = (
    enabledFlags: Array<FeatureFlag>,
    featureFlagKey: any
) => {
    return enabledFlags.includes(featureFlagKey);
};
